import { Navigate, Route, Routes } from 'react-router-dom'
import BoxTruckOfferAnalyticsPage from './BoxTruckOfferAnalyticsPage'

export default function BoxTruckOfferAnalyticsRoutes() {
    return (
        <Routes>
            <Route index element={<BoxTruckOfferAnalyticsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    )
}
